var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"share-facebook-button",attrs:{"href":"","target":"_blank"},on:{"click":function($event){$event.preventDefault();return _vm.facebookShare($event)}}},[_vm._v(" SHARE ON FACEBOOK ")])}
var staticRenderFns = []

export { render, staticRenderFns }